export function copyPhone(){
    const emergencyContact = $('.emergency-contact');
    const phone = emergencyContact.find('.phone a');
    const copyPhone = emergencyContact.find('.copy-phone');
    copyPhone.on('click', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText(phone.text())
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/copyPhone.js